import React from 'react';
import moment from 'moment';
import { Link } from 'react-router';
import { ShowIf } from 'components/utils';
import { Text } from 'components/tt-forms/common';
import fileDownload from 'js-file-download';
import { checkServerLive } from 'constants/config';
import {downloadFile} from 'components/utils';

export default class ThongTinNguoiDungDon extends React.Component {

  render() {

    return (
        <div className="box-forward">
          <div className="container-box">
            <div className="title">
              <div className="rows">
                <div className="col-12">
                  <h3>{this.props.title}</h3>
                </div>
              </div>
            </div>
            <div className="group-box">
              <div className="items-form">
                <div className="rows">
                  <Text
                    className="col-input"
                    label="Họ và tên:"
                    value={this.props.parent.dataNguoiDuocUyQuyen ? this.props.parent.dataNguoiDuocUyQuyen.hoVaTen : ''} />
                  <Text
                    className="col-input"
                    label="Ngày sinh:"
                    value={this.props.parent.dataNguoiDuocUyQuyen.ngaySinh ? moment(this.props.parent.dataNguoiDuocUyQuyen.ngaySinh).format("DD/MM/YYYY") : ''} />
                  <Text
                    className="col-input"
                    label="Giới tính:"
                    value={this.props.parent.dataNguoiDuocUyQuyen && this.props.parent.dataNguoiDuocUyQuyen.gioiTinh ? 'Nam' : "Nữ"} />
                </div>
              </div>
              <div className="items-form">
                <div className="rows">
                  <Text
                    className="col-input"
                    label="Số CMND/ Hộ chiếu:"
                    value={this.props.parent.dataNguoiDuocUyQuyen ? this.props.parent.dataNguoiDuocUyQuyen.soCMNDHoChieu : ''} />
                  <Text
                    className="col-input"
                    label="Ngày cấp:"
                    value={this.props.parent.dataNguoiDuocUyQuyen.ngayCap ? moment(this.props.parent.dataNguoiDuocUyQuyen.ngayCap).format("DD/MM/YYYY") : ''} />
                  <Text
                    className="col-input"
                    label="Nơi cấp:"
                    value={this.props.parent.dataNguoiDuocUyQuyen && this.props.parent.dataNguoiDuocUyQuyen.noiCapCMNDInfo ? this.props.parent.dataNguoiDuocUyQuyen.noiCapCMNDInfo.ten : ''} />
                  <Text
                    className="col-input"
                    label="Dân tộc:"
                    value={this.props.parent.dataNguoiDuocUyQuyen && this.props.parent.dataNguoiDuocUyQuyen.danTocCongDan ? this.props.parent.dataNguoiDuocUyQuyen.danTocCongDan.ten : ''} />
                  <Text
                    className="col-input"
                    label="Quốc tịch:"
                    value={this.props.parent.dataNguoiDuocUyQuyen && this.props.parent.dataNguoiDuocUyQuyen.quocTichCongDan ? this.props.parent.dataNguoiDuocUyQuyen.quocTichCongDan.ten : ''} />
                </div>
              </div>
              <div className="items-form">
                <div className="rows">
                  <Text
                    className="col-input"
                    label="Tỉnh:"
                    value={this.props.parent.dataNguoiDuocUyQuyen && this.props.parent.dataNguoiDuocUyQuyen.tinhThanhCongDan ? this.props.parent.dataNguoiDuocUyQuyen.tinhThanhCongDan.ten : ''} />
                  <Text
                    className="col-input"
                    label="Quận/Huyện:"
                    value={this.props.parent.dataNguoiDuocUyQuyen && this.props.parent.dataNguoiDuocUyQuyen.quanHuyenCongDan ? this.props.parent.dataNguoiDuocUyQuyen.quanHuyenCongDan.ten : ''} />
                  <Text
                    className="col-input"
                    label="Phường/Xã:"
                    value={this.props.parent.dataNguoiDuocUyQuyen && this.props.parent.dataNguoiDuocUyQuyen.phuongXaCongDan ? this.props.parent.dataNguoiDuocUyQuyen.phuongXaCongDan.ten : ''} />
                  <Text
                    className="col-w40"
                    label="Địa chỉ:"
                    value={this.props.parent.dataNguoiDuocUyQuyen ? this.props.parent.dataNguoiDuocUyQuyen.diaChi : ''} />
                </div>
              </div>
              <ShowIf condition={this.props.parent.listTepUyQuyen.length > 0}>
                <div className="items-form">
                  <div className="rows">
                    <div className="col-12">
                      <label className="pt-label">
                        <span className="val-title-bold">Giấy ủy quyền: </span>
                      </label>
                      {
                        this.props.parent.listTepUyQuyen.map((item,i) => {
                          return(
                            <p className="info-document mb5" key={i}>
                              <ShowIf condition={!checkServerLive}>
                                <Link onClick={fileDownload.bind(this, item.urlFile, item.tenFile)} className="name_upload txt-blue">{item.tenFile}</Link>
                              </ShowIf>
                              <ShowIf condition={checkServerLive}>
                                <Link onClick={()=>{downloadFile(item.urlFile, item.tenFile)}} className="name_upload txt-blue">{item.tenFile}</Link>
                              </ShowIf>
                            </p>
                          )
                        })
                      }

                    </div>
                  </div>
                </div>
              </ShowIf>

              <ShowIf condition={this.props.parent.dataNguoiDuocUyQuyen.luatSu }>
                <div className="items-form title mb5">
                  <div className="rows">
                    <div className="col-input">
                      <label className="pt-label">
                        <h3>Luật sư</h3>
                      </label>
                    </div>
                  </div>
                  <div className="rows">
                    <Text
                      className="col-input"
                      label="Số thẻ:"
                      value={this.props.parent.dataNguoiDuocUyQuyen.soTheLuatSu ? this.props.parent.dataNguoiDuocUyQuyen.soTheLuatSu : ''} />
                    <Text
                      className="col-input"
                      label="Ngày cấp:"
                      value={this.props.parent.dataNguoiDuocUyQuyen ? ((this.props.parent.dataNguoiDuocUyQuyen.ngayCapTheLuatSu == null) ? '' : moment(this.props.parent.dataNguoiDuocUyQuyen.ngayCapTheLuatSu).format('DD/MM/YYYY')) : ''} />
                    <Text
                      className="col-input"
                      label="Nơi cấp:"
                      value={this.props.parent.dataNguoiDuocUyQuyen.noiCapTheLuatSu ? this.props.parent.dataNguoiDuocUyQuyen.noiCapTheLuatSu : ''} />
                    <Text
                      className="col-input"
                      label="Thông tin giới thiệu:"
                      value={this.props.parent.dataNguoiDuocUyQuyen.thongTinGioiThieu ? this.props.parent.dataNguoiDuocUyQuyen.thongTinGioiThieu : ''} />
                  </div>
                </div>
              </ShowIf>

              <ShowIf condition={this.props.parent.listTepChungChiHanhNghe.length > 0}>
                <div className="items-form">
                  <div className="rows">
                    <div className="col-12">
                      <label className="pt-label">
                        <span className="val-title-bold">Chứng chỉ hành nghề:</span>
                      </label>
                      {
                        this.props.parent.listTepChungChiHanhNghe.map((item, i) => {
                          return (
                            <p className="info-document mb5" key={i}>
                              <ShowIf condition={!checkServerLive}>
                                <Link className="name_upload txt-blue" onClick={fileDownload.bind(this, item.urlFile, item.tenFile)} >{item.tenFile}</Link>
                              </ShowIf>
                              <ShowIf condition={checkServerLive}>
                                <Link className="name_upload txt-blue" onClick={()=>{downloadFile(item.urlFile, item.tenFile)}} >{item.tenFile}</Link>
                              </ShowIf>
                            </p>
                          )
                        })
                      }

                    </div>
                  </div>
                </div>
              </ShowIf>
            </div>
          </div>
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/letter-information/letter-detail/ThongTinNguoiUyQuyen.jsx